import { render, staticRenderFns } from "./ProductEditImages.vue?vue&type=template&id=6768f676&scoped=true"
import script from "./ProductEditImages.vue?vue&type=script&lang=ts"
export * from "./ProductEditImages.vue?vue&type=script&lang=ts"
import style0 from "./ProductEditImages.vue?vue&type=style&index=0&id=6768f676&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768f676",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6768f676')) {
      api.createRecord('6768f676', component.options)
    } else {
      api.reload('6768f676', component.options)
    }
    module.hot.accept("./ProductEditImages.vue?vue&type=template&id=6768f676&scoped=true", function () {
      api.rerender('6768f676', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditImages.vue"
export default component.exports